/* ==========================================================================
   cart-drawer-state-fix.js

   THE BUG, measured rather than guessed at:

   Adding to cart opens TWO drawers. Ours (#CustomCartDrawer) is the one you
   see. Motion's own ajax cart (#CartDrawer) opens invisibly behind it, because
   custom-cart-drawer.js fires jQuery('body').trigger('added.ajaxProduct') and
   Motion's cart is listening for exactly that.

   Motion's Drawer.open() does two things that then never get undone, because
   nothing ever calls its close():

     1. adds `js-drawer-open` to <html> and <body>
     2. binds a click handler on #MainContent that closes the drawer

   Closing OUR drawer leaves both in place. Then the next click anywhere on the
   page hits Motion's stale handler, and Drawer.close() runs:

     $nodes.parent.removeClass('js-drawer-open').addClass('js-drawer-closing')
     setTimeout(remove 'js-drawer-closing', 500)

   and theme.css says:

     .js-drawer-closing .main-content:after,
     .js-drawer-open    .main-content:after { content:''; position:fixed;
       inset:0; background:#000; opacity:0; z-index:26 }
     .js-drawer-closing .main-content:after { animation: overlay-off .4s forwards }
     @keyframes overlay-off { 0% { opacity:.6 } to { opacity:0 } }

   So the click paints a full-screen 60%-black layer that fades out over 400ms.
   That is the reported "se pone oscuro despues del click", verified by holding
   the class and reading the pseudo-element: content:"", display:block,
   opacity:0.6, background:rgb(0,0,0), z-index:26.

   Measured asymmetry worth knowing: in the js-drawer-OPEN state something on
   this store already suppresses the pseudo-element (it computes to
   content:none, display:none). The js-drawer-CLOSING state is not suppressed.
   That is why only the closing state was ever visible, and why the bug shows up
   as a flash on a later click rather than a dim page while the drawer is open.

   The same stale handler is `function(){ return this.close(), !1 }`. Returning
   false from a jQuery handler calls preventDefault AND stopPropagation, so that
   first click is also SWALLOWED -- a link does not navigate, a button does not
   fire. Same root cause, and the more damaging of the two symptoms.

   Note the theme already tried to suppress this overlay:

     #shopify-section-header .js-drawer-closing .main-content:after { display:none!important }

   That selector cannot match. .main-content is <main id="MainContent">, a
   SIBLING of the header section, not a descendant of it. The rule has never
   applied to anything.

   THE FIX: close Motion's drawer through Motion's own close button as soon as
   it opens underneath ours. That runs the real close() -- unbinding the
   #MainContent handler and clearing its isOpen flag -- so there is no stale
   state left to fire later. The overlay is suppressed for the length of that
   unwind, because ours is the overlay that should be on screen.

   Why not just hide the overlay with CSS and leave it at that: the swallowed
   click would remain, and every add-to-cart would leave another dead handler
   bound to the page.

   Why not stop firing added.ajaxProduct: other listeners (subscriptions,
   wholesale, analytics) may rely on it. Letting Motion react and then unwinding
   it is the smaller change.
   ========================================================================== */
(function () {
  'use strict';

  var OURS = 'custom-drawer-open';
  var MOTION_OPEN = 'js-drawer-open';
  var MOTION_CLOSING = 'js-drawer-closing';
  var UNWIND = 'ccd-unwind';

  var html = document.documentElement;
  var body = document.body;
  if (!body) return;

  /* Motion's page overlay, suppressed only while our drawer is the one on
     screen and while we are unwinding Motion's. The mobile nav drawer is a
     different instance and keeps its dim backdrop -- that is why this is
     scoped to two classes instead of killing .main-content:after outright. */
  var style = document.createElement('style');
  style.id = 'ccd-state-fix';
  style.textContent =
    'html.' + UNWIND + ' .main-content:after,' +
    'body.' + UNWIND + ' .main-content:after,' +
    'body.' + OURS + ' .main-content:after{' +
      'animation:none!important;opacity:0!important;display:none!important;content:none!important}';
  (document.head || html).appendChild(style);

  var unwindTimer = null;

  function unwindMotionDrawer() {
    var motion = document.getElementById('CartDrawer');
    if (!motion || motion.className.indexOf('drawer--is-open') === -1) return false;

    html.classList.add(UNWIND);
    body.classList.add(UNWIND);

    var closeBtn = motion.querySelector('.js-drawer-close');
    if (closeBtn) {
      closeBtn.click();            // Motion's real close(): unbinds and resets isOpen
    } else {
      // No close button to click: strip the state by hand. The #MainContent
      // handler survives this, so it is the worse path -- but better than
      // leaving js-drawer-open on the document.
      motion.classList.remove('drawer--is-open');
      html.classList.remove(MOTION_OPEN);
      body.classList.remove(MOTION_OPEN);
    }

    // Motion removes js-drawer-closing itself after 500ms; hold the suppression
    // a little past that so the fade never becomes visible.
    clearTimeout(unwindTimer);
    unwindTimer = setTimeout(function () {
      html.classList.remove(UNWIND);
      body.classList.remove(UNWIND);
      html.classList.remove(MOTION_CLOSING);
      body.classList.remove(MOTION_CLOSING);
    }, 700);

    return true;
  }

  /* Motion opens its drawer only after its own /cart.js round trip, so it is
     not open at the moment ours is. Watch for a short window instead of
     assuming a delay. */
  function watchForMotion() {
    var tries = 0;
    (function poll() {
      if (unwindMotionDrawer() || ++tries > 40) return;   // 40 x 100ms = 4s
      setTimeout(poll, 100);
    })();
  }

  var wasOurs = body.classList.contains(OURS);

  new MutationObserver(function () {
    var isOurs = body.classList.contains(OURS);

    if (!wasOurs && isOurs) {
      watchForMotion();
    }

    if (wasOurs && !isOurs) {
      // Belt and braces: if Motion's drawer opened and closed without us
      // catching it, clear anything it left on the document.
      unwindMotionDrawer();
      [html, body].forEach(function (el) {
        el.classList.remove(MOTION_OPEN);
      });
    }

    wasOurs = isOurs;
  }).observe(body, { attributes: true, attributeFilter: ['class'] });

  // The drawer may already be open when this file runs (bfcache, or a fast add).
  if (wasOurs) watchForMotion();
})();
